export default __webpack_public_path__ + "static/media/Harness.af174093.png";